import { render, staticRenderFns } from "./company.vue?vue&type=template&id=6b1d2ba8&scoped=true"
import script from "./company.vue?vue&type=script&lang=ts"
export * from "./company.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d2ba8",
  null
  
)

export default component.exports